import { queryClient } from 'react-query-client';

export function clearUserSession(): void {
  sessionStorage.clear();
  queryClient.clear();
}
